<template>
  <div class="h-borderBox" :style='dynamicListObject'>
  <table>
    <tr class="h-dialog-borderBox-topIcon">
      <th style="width: 100%;">
        <span style="padding: 10px;">{{title}}</span> 
      </th>  
      <th style="padding-right: 10px">
        <span class='icon hero-icon hero-icon-add-small' @click='addBtnClick()' :style='displayAdd'></span>  
      </th> 
    </tr>
    <tr v-for='item in list' :key='item.key'>
      <td>
        <slot :name='item.key'></slot>
      </td>
     <div v-if='item.key === firstFlag'>
      <td style='padding-top:39px'>      
        <span class='icon hero-icon hero-icon-remove-small'></span>  
      </td>
    </div>
    <div v-if='item.key != firstFlag'>
      <td style='padding-top:39px'>      
        <span class='icon hero-icon hero-icon-remove-small'  @click='delBtnClick(item.key)'></span>  
      </td>
    </div>

    </tr>   
  </table>
  </div>
</template>

<script>
export default {
  name: "DynamicList",
  props: [
    'title',
    'list',
    'addBtnClick',
    'delBtnClick',
    'firstFlag',
  ],
  data() {
    return {
      dynamicListObject: {
        height: '144px',
      },
      displayAdd :{
      	display: 'none'
      }
    }
  },
};
</script>
